module.exports = __webpack_public_path__ + "static/bloodpop-fbd452430f35a41cbea400e108955a29.webp";